const CREATE_COMMENT = 'CREATE_COMMENT';
const CREATE_COMMENT_FAIL = 'CREATE_COMMENT_FAIL';
const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS';
const REQUEST_COMMENTS = 'REQUEST_COMMENTS';
const REQUEST_COMMENTS_FAIL = 'REQUEST_COMMENTS_FAIL';
const REQUEST_COMMENTS_SUCCESS = 'REQUEST_COMMENTS_SUCCESS';

export {
  CREATE_COMMENT,
  CREATE_COMMENT_FAIL,
  CREATE_COMMENT_SUCCESS,
  REQUEST_COMMENTS,
  REQUEST_COMMENTS_FAIL,
  REQUEST_COMMENTS_SUCCESS,
};
